var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Tack, du kommer inte längre få dessa mejl för Bridgen.")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"11px","text-align":"center"}},[_vm._v("(Du skickas vidare automatiskt om "+_vm._s(_vm.seconds)+" sekunder)")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0d0e970","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cancel-offline-email.vue
// module id = null
// module chunks = 